<template>
    <div id="ag-grid-demo">
        <vx-card>
            <h3>File Configuration Histories</h3>
            <br><br>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                        >
                            <span
                                class="mr-2"
                            >{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="fetchData(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="dataTrx"
                rowSelection="multiple"
                colResizeDefault="shift"
                :animateRows="true"
                :floatingFilter="true"
                :pagination="true"
                :floatingFiltersHeight="2"
                :paginationPageSize="limit"
                :suppressPaginationPanel="true"
                :enableCellTextSelection="true"
            ></ag-grid-vue>
            <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage" />
        </vx-card>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { url } from "@/configs/apiUrl";
import Axios from "@/global/AxiosCall";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import ActionDownload from "./DeviceSetupConfigurationFileDownload.vue"
import ColumnClickedAgGridComponent from "@/components/cell-render-component/device-setup/ColumnClickedAgGridComponent";

export default {
    name: "DeviceSetupConfigurationFile",
    components: {
        AgGridVue,
        ActionDownload
    },
    props: {
        request_id: {
            type: Number
        }
    },
    data() {
        return {
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: true,
                filterParams: {
                applyButton: true,
                newRowsAction: 'keep'
                },
            },
            columnDefs : [
                {
                    headerName: "File Directory",
                    field: "file_dir",
                    width: 300,
                    filter: false,
                },
                {
                    headerName: "File Name",
                    field: "id",
                    width: 300,
                    cellRendererFramework: ActionDownload
                },
                {
                    headerName: "File Size",
                    field: "file_size",
                    width: 180,
                    filter: false,
                },
                {
                    headerName: "Timestamp",
                    field: "file_timestamp",
                    width: 220,
                    filter: false,
                },
                {
                    headerName: "Uploaded By",
                    field: "uploaded_by",
                    width: 200,
                    filter: false,
                },
                {
                    headerName: "Notes",
                    field: "notes",
                    width:200,
                    filter: false,
                    editable: false,
                    cellRendererFramework: ColumnClickedAgGridComponent,
                },
            ],
            dataTrx: [],
            dataCount: 0,
            totalPage: 0,
            page: 1,
            limit: 10,
            totalData: 1,
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("Channel", null);
            } else this.gridOptions.columnApi.setColumnPinned("Channel", "left");
        }
    },
    computed: {
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.fetchData(val, this.limit);
            }
        }
    },
    methods: {
        openLoading() {
            this.$vs.loading({
                type:"default",
            })
        },
        fetchData(page, limit) {
            this.openLoading()
            let newPage = page;

            if (this.dataCount != 0) {
                let totalPages = Math.ceil(this.dataCount / limit);
                if (page > totalPages) {
                newPage = totalPages;
                }
            }

            newPage
            Axios.Get(url.svd.device_setup.file + "/" + this.request_id +"?page=" + page + "&limit=" + limit).then(resp => {
                this.$vs.loading.close()
                this.dataTrx = [];
                if (resp.data.data.length != 0) {
                    this.totalData = parseInt(resp.data.total)
                    let no = ((page - 1) * limit) + 1;
                    for (let data of resp.data.data) {
                    data.no = no;
                    this.dataTrx.push(data);
                    no++;
                    }

                    this.dataCount = resp.data.total;
                    this.page = page;
                    if (limit >= this.dataCount) {
                    this.limit = this.dataTrx.length;
                    } else {
                    this.limit = limit;
                    }

                    this.gridApi.paginationSetPageSize(this.limit);
                    this.totalPage = resp.data.lastPage;
                }
            }).catch(e => {
                this.$vs.loading.close()
                console.log(e);
            })
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridOptions.getRowStyle = function(params) {
            if (params.node.rowIndex % 2 === 0) {
                return { background: '#f9f9f9' }
            }
        }
        this.gridOptions.rowHeight = 42;
    }
}
</script>

<style>

</style>